module.exports = __webpack_public_path__ + "static/media/icons.8e3c7f55.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/icons.eot
// module id = 1629
// module chunks = 0